"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = boxShadow;
function boxShadow() {
  return "\n    box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.3);\n  ";
}